<template>
  <div style="height:100%; ">
    <el-container style="height:100%;">
      <el-header class="sxb-header">
        <el-row>
          <el-col :span="12" style="text-align:left">
            <div style="font-size:30px;font-weight:bold">{{ appName }}</div>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <div></div>
            <el-popover trigger="click">
              <div>
                <div @click="update" class="head-menubg">修改密码</div>
                <div @click="loginOut" class="head-menubg">退出登录</div>
              </div>
              <el-avatar
                icon="el-icon-user-solid"
                slot="reference"
                style="margin-top:10px;cursor:pointer;"
              ></el-avatar>
            </el-popover>
          </el-col>
        </el-row>
      </el-header>
      <el-container style="margin-top:5px;">
        <el-aside class="left-menu-bg" width="200px">
          <div :style="mainstyle">
            <el-menu
              :default-active="defaultMenu.route"
              @select="menuSelect"
              background-color="#545c64"
              text-color="white"
              active-text-color="#ffd04b"
              style="border:0px;"
            >
              <template v-for="(item, idx) in this.menuList">
                <el-menu-item
                  v-if="!item.hasSub"
                  :index="item.route"
                  :route="item.route"
                  :key="idx"
                >
                  <i :class="item.class" style="color:white;"></i>
                  <span slot="title"> {{ item.name }}</span>
                </el-menu-item>
                <el-submenu v-if="item.hasSub" :index="item.index" :key="idx">
                  <template slot="title">
                    <i :class="item.class" style="color:white;"></i>
                    <span>{{ item.name }}</span>
                  </template>
                  <el-menu-item
                    v-for="sub in item.subItem"
                    :index="sub.route"
                    :key="sub.index"
                    :route="sub.route"
                    >{{ sub.name }}</el-menu-item
                  >
                </el-submenu>
              </template>
            </el-menu>
          </div>
        </el-aside>

        <el-main :style="mainstyle">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialog"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form
        :model="editorForm"
        :rules="rules"
        ref="editorForm"
        label-width="100px"
        style="text-align:left"
      >
        <el-form-item label="手机号:" prop="userPhone">
          <el-input
            v-model="editorForm.userPhone"
            placeholder="请输入手机号"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码:" prop="checkCode">
          <el-input
            v-model="editorForm.checkCode"
            placeholder="请输入验证码"
            autocomplete="off"
            auto-complete="off"
          >
            <template slot="append">
              <el-button @click="getCheckCode">发送验证码</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码:" prop="password">
          <el-input
            type="text"
            @focus="changePwdType"
            v-model="editorForm.password"
            placeholder="请输入新密码"
            autocomplete="off"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码确认:" prop="password2">
          <el-input
            type="text"
            @focus="changePwdType"
            v-model="editorForm.password2"
            placeholder="请重新输入密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align:center;">
          <el-button type="primary" @click="submitForm()">确定</el-button>
          <el-button @click="cancelForm()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import common from "../../public/static/common";
export default {
  name: "index",
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.editorForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      appName: common.appName,
      mainstyle: {
        height:
          document.documentElement.clientHeight - 60 + "px" ||
          document.body.clientHeight - 60 + "px",
        "margin-left": "5px",
      },
      defaultMenu: { index: "-1" },
      menuList: [],
      editorForm: {
        id: "",
        modifyUser: "",
        userPhone: "",
        checkCode: "",
        password: "",
        password2: "",
      },
      passwordDialog: false,
      rules: {
        userPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        checkCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password2: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  methods: {
    getMenuList() {
      let usercode = common.getCurrUser().userCode;
      //console.log("get", usercode);
      let url = "/extwarapi/api/rights/getMenu";
      let param = { code: usercode };
      this.axios
        .post(url, param)
        .then((resp) => {
          if (resp.data.code == "0000") {
            this.menuList = resp.data.result.menuList;
            let defaultMenu = this.getDefaultMenu();
            this.defaultMenu = defaultMenu;
            this.$router.push({ name: this.defaultMenu.route });
          }
        })
        .catch((resp) => {
          //console.log("error", resp);
        });
    },
    //默认当前菜单,默认最多二级菜单
    getDefaultMenu() {
      let currRoute = this.$route.path;
      let defaultMenu = "";
      if (currRoute.indexOf("index") > -1) {
        let firstMenu = this.menuList[0];
        //console.log(firstMenu.subItem[0]);
        if (firstMenu.route) {
          // defaultUrl = firstMenu.route;
          defaultMenu = firstMenu;
        } else {
          // defaultUrl = firstMenu.subItem[0].route;
          defaultMenu = firstMenu.subItem[0];
        }
      } else {
        currRoute = currRoute.replace("/", "");
        let obj = common.getItemByKeyVal(
          this.menuList,
          "route",
          currRoute,
          "subItem"
        );
        defaultMenu = obj;
      }
      //console.log("index.vue-", currRoute, "-default-", defaultMenu);
      return defaultMenu;
    },

    menuSelect(index, keyPath, obj) {
      this.defaultMenu = obj;
      this.$router.push(obj.route);
    },
    initUser() {
      let suser = window.sessionStorage.getItem("suser");
      let userInfo = JSON.parse(suser);
      this.editorForm.userPhone = userInfo.userPhone;
      this.editorForm.id = userInfo.id;
      this.editorForm.modifyUser = userInfo.userCode;
    },
    update() {
      this.initUser();
      this.passwordDialog = true;
    },
    getCheckCode() {
      let url = "/extwarapi/getCheckCode";
      let param = this.editorForm;
      let me = this;
      this.axios
        .post(url, param)
        .then((resp) => {
          //console.log("resp", resp.data.result.checkCode);
          me.editorForm.checkCode = resp.data.result.checkCode;
        })
        .catch((resp) => {
          //console.log("error", resp);
        });
    },
    changePwdType(e) {
      e.srcElement.type = "password";
    },
    submitForm() {
      this.$refs["editorForm"].validate((valid) => {
        if (valid) {
          let url = "extwarapi/api/user/updatePwd";
          let param = this.editorForm;
          this.axios
            .post(url, param)
            .then((resp) => {
              if (resp.data.code == "0000") {
                this.$message("修改成功");
                this.passwordDialog = false;
              } else {
                this.$message(resp.data.msg);
              }
            })
            .catch((resp) => {
              this.$message(resp.data.msg);
            });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    cancelForm() {
      this.passwordDialog = false;
    },
    loginOut() {
      this.$confirm("退出登录确定退出当前登录账号？", "退出登录", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //调用退出接口，清除服务器缓存等...
          let url = "/extwarapi/logout";
          this.initUser();
          let param = this.editorForm;
          let me = this;
          this.axios
            .post(url, param)
            .then((resp) => {})
            .catch((resp) => {
              //console.log("error", resp);
            });

          this.$router.push({ name: "login" });
        })
        .catch(() => {});
    },
  },
  created() {
    this.getMenuList();
  },
  mounted() {},
  watch: {
    $route(route) {
      console.log('route',route)
      // this.activeIndex = route.meta.active;
    }
  }
};
</script>

<style>
.el-header {
  background-color: #b3c0d1;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  background-color: #d3dce6;
  text-align: left;
  line-height: 200px;
}

.el-main {
  background-color: #e9eef3;
  text-align: center;
}

.left-menu-bg {
  background-color: #545c64;
  color: white;
}
.head-menubg:hover {
  background-color: #565a5d;
}
.head-menubg {
  background-color: #9b9fa3;
  line-height: 30px;
  text-align: center;
  margin-top: 5px;
  cursor: pointer;
  color: white;
}
.sxb-header {
  background-color: #545c64;
  color: white;
}

.scrollbar-wrapper {
  height: 90%;
  overflow-x: hidden !important;
}
</style>
